var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { width, space } from 'styled-system';
import { buttonStyles } from '../Button';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
var variations = {
    fill: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "], ["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "])), buttonStyles),
    link: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  "], ["\n    cursor: pointer;\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  "])), getPaletteColor('base'), getPaletteColor('dark')),
    outline: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "], ["\n    &:hover {\n      text-decoration: none;\n    }\n\n    ", "\n  "])), buttonStyles),
};
var propTypes = {
    color: deprecatedColorValue(),
    variation: PropTypes.oneOf(Object.keys(variations)),
};
var Link = styled.a.attrs(function (_a) {
    var target = _a.target, props = __rest(_a, ["target"]);
    return (__assign({ rel: target === '_blank' ? 'noopener' : null, target: target }, props));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", " ", ";\n"], ["\n  ", "\n  ", " ", ";\n"])), applyVariations('Link', variations), width, space);
Link.displayName = 'Link';
Link.defaultProps = {
    color: 'primary',
    variation: 'link',
    size: 'medium',
};
Link.propTypes = propTypes;
export default Link;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Link.js.map